(() => {
  const dates = Object.freeze({
    show: Date.parse('2026-12-26T00:00:00+01:00'),
    start: Date.parse('2026-12-26T00:00:00+01:00'),
    end: Date.parse('2027-01-01T00:00:00+01:00')
  });
  const phaseAt = now => now < dates.start || now >= dates.end ? 'off' : 'live';
  let timer;

  const refresh = () => {
    clearTimeout(timer);
    const now = Date.now();
    const phase = phaseAt(now);
    const active = phase !== 'off';
    const root = document.body;
    root.classList.toggle('veko-year-end-2026', active);
    root.dataset.vekoYearEndPhase = phase;
    document.querySelectorAll('[data-veko-year-end-event]').forEach(node => { node.hidden = !active; });
    document.querySelectorAll('[data-veko-year-end-default]').forEach(node => { node.hidden = active; });
    document.querySelectorAll('[data-veko-year-end-announcement]').forEach(node => { node.hidden = node.dataset.vekoYearEndAnnouncement !== phase; });
    document.querySelectorAll('[data-veko-year-end-copy]').forEach(node => { node.hidden = node.dataset.vekoYearEndCopy !== phase; });

    if (active) {
      document.querySelectorAll('[data-veko-year-end-art] template').forEach(template => {
        template.replaceWith(template.content.cloneNode(true));
      });
      const target = dates.end;
      const seconds = Math.max(0, Math.ceil((target - now) / 1000));
      const units = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600) % 24,
        minutes: Math.floor(seconds / 60) % 60,
        seconds: seconds % 60
      };
      document.querySelectorAll('[data-veko-year-end-clock]').forEach(clock => {
        clock.hidden = false;
        Object.entries(units).forEach(([unit, value]) => {
          const digit = clock.querySelector('[data-unit="' + unit + '"]');
          if (digit) digit.textContent = String(value).padStart(2, '0');
        });
      });
    }
    if (now < dates.end) {
      const delay = active ? 1000 - now % 1000 : Math.min(dates.show - now, 86400000);
      timer = setTimeout(refresh, Math.max(20, delay));
    }
  };

  const bindShare = () => {
    document.querySelectorAll('[data-veko-year-end-share]').forEach(button => {
      if (button.dataset.bound === 'true' || typeof navigator.share !== 'function') return;
      button.dataset.bound = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const event = button.closest('[data-veko-year-end-event]');
        if (!event || phaseAt(Date.now()) === 'off') return;
        navigator.share({
          title: event.dataset.shareTitle,
          text: event.dataset.shareText,
          url: new URL(window.vekoRoutes?.root || '/', window.location.origin).href
        }).catch(() => {});
      });
    });
  };

  bindShare();
  refresh();
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearTimeout(timer);
    else refresh();
  });
  document.addEventListener('shopify:section:load', () => {
    bindShare();
    refresh();
  });
  window.addEventListener('pageshow', refresh);
})();

